import axios from "axios"
import { authStorageKey } from "../utils"
import { Alert } from "reactstrap"
import { openCortesiaModal } from "../modalBridge"

const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
})

api.interceptors.request.use(async (config) => {
	try {
		let auth = localStorage.getItem(authStorageKey)
		if (auth) {
			const authObj = JSON.parse(auth)
			config.headers.Authorization = `Bearer ${authObj.token}`
		}

		const jsonEmpresa = localStorage.getItem("@playnee-empresa")
		const empresaLogada = JSON.parse(jsonEmpresa)
		config.headers.empresa_id = empresaLogada.id
	} catch (error) {
		console.log(error)
	}

	return config
})

// ----- RESPONSE -----
api.interceptors.response.use(
	(res) => res,
	(err) => {
		const { response } = err
		if (!response) return Promise.reject(err) // erro de rede

		if (response.status === 403) {
			const { message, expiresAt, code } = response.data || {}

			// trate pelo "code" se você adicionar no backend (recomendado)
			if (message === "Período de cortesia expirado" || code === "CORTESIA_EXPIRED") {
				// EXEMPLOS:
				openCortesiaModal(expiresAt)
				// openModalCortesia(expiresAt);
				// store.dispatch(showCortesiaModal({ expiresAt }));
				// toast.error('Seu período de cortesia expirou!');
				// history.push('/assinatura');

				return Promise.reject(err) // mantém o fluxo de erro original
			}
		}

		return Promise.reject(err)
	}
)

export default api
